import axios from 'axios'
import { Message } from 'element-ui'

/**
 * 创建 axios 请求实例
 * 统一封装：baseURL、超时、Token注入、响应拦截、错误处理
 */
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || process.env.VUE_APP_BASE_API || '/api',
  timeout: 15000
})

/**
 * 请求拦截器 —— 自动注入 Token
 */
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

/**
 * 响应拦截器 —— 统一处理业务状态码 & HTTP 错误
 */
service.interceptors.response.use(
  response => {
    const res = response.data
    // 业务状态码非 200 时提示并 reject
    if (res.code !== 200) {
      // 401 未授权：清除登录态并跳转登录页
      if (res.code === 401) {
        const isLoginPage = window.location.hash === '#/login'
        localStorage.removeItem('token')
        if (!isLoginPage) {
          Message.error(res.message || '登录已过期，请重新登录')
          // 避免多个请求同时触发多个跳转，加一个时间标记
          if (!window.__last401Redirect || Date.now() - window.__last401Redirect > 2000) {
            window.__last401Redirect = Date.now()
            setTimeout(() => {
              window.location.hash = '#/login'
            }, 500)
          }
        }
        return Promise.reject(new Error(res.message || 'Unauthorized'))
      }
      Message.error(res.message || '请求失败')
      return Promise.reject(new Error(res.message || 'Error'))
    }
    return res
  },
  error => {
    // HTTP 状态码异常处理
    if (error.response) {
      const { status } = error.response
      switch (status) {
        case 401: {
          // Token 过期，清除登录态并跳转登录页
          // 登录页不弹提示，避免干扰
          const isLoginPage = window.location.hash === '#/login'
          localStorage.removeItem('token')
          if (!isLoginPage) {
            Message.error('登录已过期，请重新登录')
            window.location.hash = '#/login'
          }
          break
        }
        case 403:
          Message.error('没有权限执行此操作')
          break
        case 404:
          Message.error('请求的资源不存在')
          break
        case 500:
          Message.error('服务器内部错误')
          break
        default:
          Message.error(error.message || '网络错误')
      }
    } else {
      Message.error('网络连接失败，请检查网络')
    }
    return Promise.reject(error)
  }
)

export default service
